module.exports = __webpack_public_path__ + "static/media/10.552f1bb9.jpg";